import { useEffect, useMemo, useState } from 'react';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';

import { ProdutorService } from  '../../shared/services/api/cadastros/ProdutorService';
import { useDebounce } from '../../shared/hooks';
import { useField } from '@unform/core';


type TAutoCompleteOption = {
  idprodutor: number;
  label: string;
}

interface IAutoCompleteProdutorProps {
  isExternalLoading?: boolean;
  id?: (novoTextoselect: number | undefined) => void;
}
export const AutoCompleteProdutor: React.FC<IAutoCompleteProdutorProps> = ({ isExternalLoading = false, id }) => {
  const { fieldName, registerField, defaultValue, error, clearError } = useField('idprodutor');
  const { debounce } = useDebounce();

  const [selectedId, setSelectedId] = useState<number | undefined>(defaultValue);

  const [opcoes, setOpcoes] = useState<TAutoCompleteOption[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [busca, setBusca] = useState('');

  useEffect(() => {
    registerField({
      name: fieldName,
      getValue: () => selectedId,
      setValue: (_, newSelectedId) => setSelectedId(newSelectedId),
    });
  }, [registerField, fieldName, selectedId]);

  useEffect(() => {
    setIsLoading(true);
 
    debounce(() => {
      ProdutorService.getAlllist(1, busca)
        .then((result) => {
          setIsLoading(false);

          if (result instanceof Error) {
            // alert(result.message);
          } else {
            setOpcoes(result.data.map(produtor => ({ idprodutor: produtor.idprodutor, label: produtor.nome })));
          }
        });
    });
  }, [busca]);

  const autoCompleteSelectedOption = useMemo(() => {
    if (!selectedId) return null;

    const selectedOption = opcoes.find(opcao => opcao.idprodutor === selectedId);
    if (!selectedOption) return null;

    return selectedOption;
  }, [selectedId, opcoes]);


  return (
    <Autocomplete
      openText='Abrir'
      closeText='Fechar'
      noOptionsText='Sem opções'
      loadingText='Carregando...'

      disablePortal

      options={opcoes}
      loading={isLoading}
      disabled={isExternalLoading}
      value={autoCompleteSelectedOption}
      // Só busca sozinho por `reason==='input'` — ver AutoCompleteMunicipio.tsx pro caso
      // completo do loop que isso evita (reset automático do MUI virando busca).
      onInputChange={(_, newValue, reason) => {
        if (reason === 'input') setBusca(newValue);
      }}
      onChange={(_, newValue) => { setSelectedId(newValue?.idprodutor); id?.(newValue?.idprodutor); setBusca(''); clearError(); }}
      popupIcon={(isLoading) ? <CircularProgress size={28} /> : undefined}
      renderInput={(params) => (
        <TextField
          {...params}
          size='small'
          label="Produtor"
          error={!!error}
          helperText={error}
        />
      )}
    />
  );
};